import React, { useState, useEffect, useContext } from "react";
import { DelayLink } from "./DelayLink";
import { Button } from "./Button";
import "./../styles/Navbar.css";
import {
  AccountCircleOutlined,
  HomeOutlined,
  TaskAltOutlined,
  FactCheckOutlined,
  MonitorHeartOutlined,
  AssessmentOutlined,
  Home,
} from "@mui/icons-material";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import DashboardIcon from "@mui/icons-material/DashboardTwoTone";
import SettingsIcon from "@mui/icons-material/Settings";
import PersonIcon from "@mui/icons-material/Person";
import RssFeedIcon from "@mui/icons-material/RssFeed";
import { Link } from "react-router-dom";
import FaxIcon from "@mui/icons-material/Fax";
import LogoutIcon from "@mui/icons-material/Logout";
import menus from "../../../src/user-config.json";
import UserContext from "../Common/UserContext";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useLocation } from "react-router-dom";
import "../styles/Navabar2.css";
import info from "../../info.json";

const differentTypeofUsers = Object.keys(menus);
const differentLandingPages = differentTypeofUsers
  .map((item) => {
    return menus[item]["menus"].filter(
      (item2) => item2.hasOwnProperty("landingPage") && item != "presenter"
    )?.[0];
  })
  .filter((item) => item != undefined)
  .map((item) => item["route"]);
function Navbar2() {
  //States===================================================================================================
  const [click, setClick] = useState(false);
  const [roleForPresenter, setRoleForPresenter] = useState("");
  const [roles, setRoles] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const {
    //Getting User Details from User Context
    userRole: user,
    userName,
    setUserRole: setUser,
    setUserName,
    isPresenter,
    setIsPresenter,
  } = useContext(UserContext);
  const [button, setButton] = useState(true);
  const [isArraowclicked, setIsArrowClicked] = useState(false);
  const instance = info.INSTACE;
  const pointToAfterLogout = instance == "DEMO" ? "/Login" : "/";

  useEffect(() => {
    showButton();
  }, []);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => {
    setClick(false);
  };

  const showButton = () => {
    if (window.innerWidth <= 1080) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  const ResetMenu = () => {
    sessionStorage.clear();
  };

  const togggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleSelect = (link) => {
    setRoleForPresenter(link);
    setIsOpen(false);
  };
  const history = useHistory();

  console.log(isPresenter);

  window.addEventListener("resize", showButton);
  // useEffect(() => {
  //   console.log("_____runnin__");
  //   return history.listen((location, action) => {
  //     if (action === "POP") {
  //       console.log("------=---------");
  //       if (differentLandingPages.includes(location.pathname)) {
  //         console.log("---------------yes-------------");
  //         const arrayUsers = JSON.parse(sessionStorage.getItem("prevRoles"));
  //         console.log(JSON.parse(sessionStorage.getItem("prevRoles")));
  //         sessionStorage.setItem("userRole", arrayUsers.pop());
  //         setUser(arrayUsers.pop());
  //         sessionStorage.setItem("prevRoles", arrayUsers);
  //       }
  //     }
  //   });
  // }, [location.pathname]);

  useEffect(() => {
    if (isPresenter && roleForPresenter) {
      // if (sessionStorage.getItem("prevRole")) {
      //   sessionStorage.setItem(
      //     "prevRoles",
      //     JSON.stringify([sessionStorage.getItem("userRole")])
      //   );
      // } else {
      //   // Retrieve the array stored as a string and parse it back to an array
      //   let prevRolesArray = JSON.parse(sessionStorage.getItem("prevRoles"));

      //   // Check if prevRolesArray is null
      //   if (prevRolesArray === null) {
      //     prevRolesArray = [];
      //   }

      //   prevRolesArray.push(sessionStorage.getItem("userRole"));

      //   sessionStorage.setItem("prevRoles", JSON.stringify(prevRolesArray));
      // }
      sessionStorage.setItem("userRole", roleForPresenter);
      setUser(roleForPresenter);
      history.push(
        menus[roleForPresenter.toLowerCase()]["menus"].find(
          (item) => item.landingPage === true
        )["route"]
      );

      sessionStorage.setItem(
        "RedirectPage",
        menus[roleForPresenter.toLowerCase()]["menus"].find(
          (item) => item.landingPage === true
        )["route"]
      );

      sessionStorage.setItem(
        "Clinical",
        menus[roleForPresenter.toLowerCase()]["clinical"]
      );
    }
  }, [roleForPresenter]);

  {
    return (
      <>
        <nav className="topHeader-wrap">
          <div className="logo-wrap">
            <DelayLink to="/" className="exlLogo" onClick={ResetMenu}>
              <img src="img/logo/cmy_logo.svg" className="logo" alt="exl" />
            </DelayLink>
            <div className="v">
              <img
                src="img/logo/logo-icon.png"
                className="logo-icon"
                alt="exl logo icon"
              />
            </div>
            <PersonIcon style={{ marginRight: "10px" }} />{" "}
            <div style={{ fontSize: "20px" }}>
              {userName} | {user}{" "}
              {isPresenter && (
                // <span
                //   className="custom-select"
                //   style={{ position: "relative" }}
                // >
                //   <span
                //     onClick={() => setIsArrowClicked(!isArraowclicked)}
                //     style={{ cursor: "pointer" }}
                //   >
                //     &#9660;
                //   </span>
                //   <select
                //     value={roleForPresenter}
                //     onChange={(e) => setRoleForPresenter(e.target.value)}
                //     style={{
                //       position: "absolute",
                //       left: "0",
                //       width: "20px",
                //       opacity: "0",
                //       width: "120px",
                //     }}
                //   >
                //     <option value="" disabled>
                //       Select Role...
                //     </option>
                //     <option
                //       value="Supervisor"
                //       // style={{ display: isArraowclicked ? "block" : "none" }}
                //     >
                //       Supervisor
                //     </option>
                //     <option
                //       value="Nurse"
                //       // style={{ display: isArraowclicked ? "block" : "none" }}
                //     >
                //       Nurse
                //     </option>
                //     <option
                //       value="Auditor"
                //       // style={{ display: isArraowclicked ? "block" : "none" }}
                //     >
                //       Auditor
                //     </option>
                //     <option
                //       value="Intake User"
                //       // style={{ display: isArraowclicked ? "block" : "none" }}
                //     >
                //       Intake User
                //     </option>
                //   </select>
                // </span>
                <div className="dropdown">
                  <button onClick={togggleDropdown} className="dropbtn">
                    &#9660;
                  </button>
                  {isOpen && (
                    <div className="dropdown-content">
                      <a href="#" onClick={() => handleSelect("Supervisor")}>
                        Supervisor
                      </a>
                      <a href="#" onClick={() => handleSelect("Nurse")}>
                        Nurse
                      </a>
                      <a href="#" onClick={() => handleSelect("Auditor")}>
                        Auditor
                      </a>
                      <a href="#" onClick={() => handleSelect("Intake User")}>
                        Intake User
                      </a>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="rightmenu">
            <div className="navbar-profile-container">
              {/* ==========================For Logged In User Showing all the items that need to be shown in its Navbar============== */}
              {menus[user.toLowerCase()]["menus"].map((item) => (
                <>
                  {button && (
                    <Link
                      to={item.route}
                      buttonStyle="btn--noOutline"
                      title={item.title}
                      style={{
                        display: item.title === "" ? "none" : "",
                      }}
                    >
                      {item.icon == "Dashboard" && (
                        <>
                          <DashboardIcon />
                          {item.title}{" "}
                        </>
                      )}

                      {item.icon == "Home" && (
                        <>
                          <HomeOutlined />
                          {item.title}{" "}
                        </>
                      )}
                      {item.icon == "Feed" && (
                        <>
                          <DynamicFeedIcon />
                          {item.title}{" "}
                        </>
                      )}
                      {item.icon == "Fax" && (
                        <>
                          <FaxIcon />
                          {item.title}{" "}
                        </>
                      )}
                      {item.icon == "Settings" && (
                        <>
                          <SettingsIcon />
                          {item.title}{" "}
                        </>
                      )}
                      {item.icon == "User" && (
                        <>
                          <PersonIcon />
                          {item.title}{" "}
                        </>
                      )}
                      {item.icon == "Assignment" && (
                        <>
                          <DynamicFeedIcon />
                          {item.title}{" "}
                        </>
                      )}
                    </Link>
                  )}
                </>
              ))}

              {button && (
                <Link
                  to={pointToAfterLogout}
                  buttonStyle="btn--noOutline"
                  title={userName}
                  onClick={() => {
                    // On Clicking the Logout Button restting all the states in session Storage
                    setUser("");
                    setUserName("");
                    setIsPresenter(false);
                    sessionStorage.clear();
                  }}
                >
                  <LogoutIcon /> Logout
                </Link>
              )}
            </div>
          </div>
        </nav>
      </>
    );
  }
}

export default Navbar2;
